'use client';
import CheckBoxGroup from '@/components/shared/checkbox-group/checkbox-group.component';
import CustomCheckBox from '@/components/shared/custom-check-box/custom-check-box.component';
import Typography from '@/components/shared/typography/typography.component';
import { useState } from 'react';
import { useTranslation } from '@/hook';
import { ArrowDarkDown } from '../../../../public/Images';
import { MakeFilterUiOject } from '@/types';
import classes from './styles.module.scss';
import Image from 'next/image';

const FilterMultiSelect = ({
    text,
    selected,
    checkBoxClicked,
    value,
    img,
    dropdownData,
}: {
    text: string;
    value: string;
    selected: boolean;
    checkBoxClicked: (vehicle: { make: string; model: string }) => void;
    img?: string | undefined;
    dropdownData: MakeFilterUiOject;
}) => {
    const { t, i18n } = useTranslation();
    const IS_RTL = i18n.language === 'ar';
    const [isOpen, setIsOpen] = useState(false);
    const makeClicked = () => {
        checkBoxClicked({ make: value, model: '' });
    };
    const modelCheckBoxClicked = (modelValue: string) => {
        checkBoxClicked({ make: value, model: modelValue });
    };
    return (
        <div
            className={`${classes.container} ${selected ? classes.active : ''}`}
        >
            <div className={classes.container__header}>
                <div
                    onClick={() => makeClicked()}
                    className={classes.container__header__content}
                >
                    {img && (
                        <Image
                            width={28}
                            height={28}
                            quality={80}
                            style={{
                                width: '28px',
                                marginRight: IS_RTL ? '' : '12px',
                                marginLeft: IS_RTL ? '12px' : '',
                            }}
                            src={img}
                            alt={text}
                        />
                    )}
                    {/*
            @eslint-disable-next-line @typescript-eslint/ban-ts-comment
          @ts-ignore */}
                    <Typography
                        className={classes.container__header__content__text}
                        variant={'body2Medium'}
                    >
                        {t(text as unknown as TemplateStringsArray)}
                    </Typography>
                </div>
                <div className={classes.container__header__actions}>
                    <CustomCheckBox
                        selected={selected}
                        checkBoxClicked={makeClicked}
                    />
                    <Image
                        width={10}
                        height={18}
                        style={{
                            transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
                            cursor: 'pointer',
                            width: '10px',
                            height: '18px',
                        }}
                        onClick={() => setIsOpen(!isOpen)}
                        src={ArrowDarkDown.src}
                        alt="arrow"
                    />
                </div>
            </div>
            <div
                className={`${classes.container__models} ${
                    isOpen ? classes.active : ''
                }`}
            >
                <div className={classes.container__models__text}>
                    {t('model')}
                </div>
                {dropdownData.models.map(model => (
                    <div
                        key={model.text}
                        className={classes.container__models__checkbox}
                    >
                        <CheckBoxGroup
                            text={model.text}
                            selected={model.selected}
                            checkBoxClicked={modelCheckBoxClicked}
                            value={model.value}
                            img={img ? img : undefined}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FilterMultiSelect;
